<div class="mat-form-field sc-help-button-wrapper">
    <ng-container [ngSwitch]="primaryStyle">
        <button #btnHelpEl type="button" mat-mini-fab [id]="fieldName"  class="sc-help-close"
            (click)="openHelpPopup($event,componentDefinition.helpFieldName, btnHelpEl)"
                matTooltip="{{componentDefinition.label}}">
            <mat-icon >help_outline</mat-icon>
        </button>
    </ng-container>

</div>
